var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotesTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#001752"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6663 11.8914V15.3335C21.6663 15.8002 21.6663 16.0335 21.7572 16.2118C21.8371 16.3686 21.9645 16.4961 22.1213 16.576C22.2996 16.6668 22.533 16.6668 22.9997 16.6668H26.4418M21.6663 24.1667H16.6663M23.333 20.8334H16.6663M26.6663 18.3236V24.3334C26.6663 25.7335 26.6663 26.4336 26.3939 26.9684C26.1542 27.4388 25.7717 27.8212 25.3013 28.0609C24.7665 28.3334 24.0665 28.3334 22.6663 28.3334H17.333C15.9329 28.3334 15.2328 28.3334 14.698 28.0609C14.2276 27.8212 13.8452 27.4388 13.6055 26.9684C13.333 26.4336 13.333 25.7335 13.333 24.3334V15.6667C13.333 14.2666 13.333 13.5666 13.6055 13.0318C13.8452 12.5614 14.2276 12.1789 14.698 11.9392C15.2328 11.6667 15.9329 11.6667 17.333 11.6667H20.0095C20.621 11.6667 20.9267 11.6667 21.2144 11.7358C21.4695 11.7971 21.7134 11.8981 21.9371 12.0351C22.1893 12.1898 22.4055 12.4059 22.8379 12.8383L25.4948 15.4952C25.9271 15.9276 26.1433 16.1437 26.2979 16.396C26.435 16.6197 26.536 16.8636 26.5973 17.1187C26.6663 17.4064 26.6663 17.7121 26.6663 18.3236Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_820_2423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0003 12.8334C36.222 12.8334 38.8337 10.2217 38.8337 7.00008C38.8337 3.77842 36.222 1.16675 33.0003 1.16675C29.7787 1.16675 27.167 3.77842 27.167 7.00008C27.167 10.2217 29.7787 12.8334 33.0003 12.8334Z",
    fill: "#00D19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3753 7.00008L32.1253 8.75008L35.6253 5.25008M38.8337 7.00008C38.8337 10.2217 36.222 12.8334 33.0003 12.8334C29.7787 12.8334 27.167 10.2217 27.167 7.00008C27.167 3.77842 29.7787 1.16675 33.0003 1.16675C36.222 1.16675 38.8337 3.77842 38.8337 7.00008Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_820_2423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesTick);
export default __webpack_public_path__ + "static/media/notes-tick.a17f0584a938301a46738056c301f06e.svg";
export { ForwardRef as ReactComponent };